import { workspaceRoutes, workspaceNavigationItems } from "./router";
/**
 * Workspace Module — tenant-level configuration (settings, RFM, etc.).
 *
 * Intentionally separate from the Organisation module: "Organisation" in this
 * app refers to a CRM entity, whereas "Workspace" describes the tenant's own
 * configuration surface. Putting these settings under their own module avoids
 * confusing the two.
 */
export class WorkspaceModule {
    constructor() {
        Object.defineProperty(this, "contracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    register(contracts) {
        this.contracts = contracts;
        contracts.logger.debug("[WorkspaceModule] Registered");
        return {
            id: "workspace",
            name: "Workspace Module",
            version: "1.0.0",
        };
    }
    getRoutes() {
        return workspaceRoutes;
    }
    getNavigationItems() {
        return workspaceNavigationItems;
    }
    getComponent() {
        return null;
    }
    unregister() {
        this.contracts?.logger.debug("[WorkspaceModule] Unregistered");
        this.contracts = null;
    }
}
export default new WorkspaceModule();
